import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
    main: {
        color: "white",
    },
    logo: {
        width: "100%",
        position: "absolute",
    },
    header: {
        position: "relative",
        alignItems: "center",
        textAlign: "center",
    },
    logoContainer: {
        width: "100%",
        height: "500px",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
    },
    teamName: {
        fontSize: "50px",
        fontFamily: "Georgia",
    },
    teamDescription: {
        fontSize: "30px",
        fontFamily: "Comic Sans MS, Comic Sans, cursive",
        fontStyle: "italic",
        paddingTop: "5.4rem",
    },
    introduction: { width: "50%", padding: "0px 100px", textAlign: "center" },
    introductionTitle: { width: "50%", padding: "0px 100px" },
    teamMentor: {
        textDecoration: "none",
        color: "#87CEEB",
    },
    meetTheTeam: {
        width: "100%",
        padding: "200px 0 150px 0",
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "center",
        backgroundColor: "#7f5a83",
        backgroundImage: "linear-gradient(#000, #203A43)",
        marginBottom: "100px",
    },
    research: {
        textColor: "white",
        textAlign: "center",
        padding: "100px 0px 50px",
    },
    buttonSubmit: {
        backgroundColor: "#C0C0C0",
        "&:hover": {
            backgroundColor: "white",
        },
    },
}));

export default useStyles;
